import PeriodSelectorJson from './interfaces/PeriodSelectorJson'
import RelativeDurationPeriod from '../../period/RelativeDurationPeriod'

export default class PeriodSelector {
  minDuration: RelativeDurationPeriod
  maxDuration: RelativeDurationPeriod | null

  constructor(
    minDuration: RelativeDurationPeriod,
    maxDuration: RelativeDurationPeriod | null,
  ) {
    this.minDuration = minDuration
    this.maxDuration = maxDuration
  }

  static fromJson(data: PeriodSelectorJson) {
    return new this(
      RelativeDurationPeriod.fromJson(data.minDuration),
      data.maxDuration
        ? RelativeDurationPeriod.fromJson(data.maxDuration)
        : null,
    )
  }
}
